module.exports = __webpack_public_path__ + "img/instagram.2d3b00dd.svg";